import React from "react";

import { Component } from "../../../../commons/types/component";
import cn from "../../libs/class-name";

interface Props extends Component {
  logo: React.ReactNode;
  indicator?: React.ReactNode;
  hint?: React.ReactNode;
}

const SplashScreenLayout = ({ classNames = [], logo, indicator = null, hint = null }: Props) => (
  <section className={cn("SplashScreenLayout", [], classNames)}>
    <div className="SplashScreenLayout__logo">{logo}</div>
    <div className="SplashScreenLayout__status">
      {indicator && <div className="SplashScreenLayout__indicator">{indicator}</div>}
      {hint && <div className="SplashScreenLayout__hint">{hint}</div>}
    </div>
  </section>
);

export default SplashScreenLayout;
